import { render } from "./CartCount.vue?vue&type=template&id=2e123a8c&scoped=true"
import script from "./CartCount.vue?vue&type=script&lang=js"
export * from "./CartCount.vue?vue&type=script&lang=js"

import "./CartCount.vue?vue&type=style&index=0&id=2e123a8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e123a8c"]])

export default __exports__